import axios from 'axios'

const phenotypeModule = {
    namespaced: true,
    state: {
      returnRoute: {
        name: null,
        path: null,
        reservation: false,
      },
      currentPhenotype: "own",
      phenotype: {
        own: {},
        partner: {}
      }
    },
    getters: {
      getReturnRoute(state) {
        return state.returnRoute
      },
      getPhenotype(state) {
        return state.phenotype
      },
      getCurrentPhenotype(state) {
        return state.currentPhenotype
      },
      isOwnPhenotype(state) {
        return state.currentPhenotype == "own" ? true : false
      },
      hasCurrentPhenotype(state) {
        return Object.keys(state.phenotype[state.currentPhenotype]).length === 0 ? false : true
      },
      hasPhenotypeMode: (state) => (mode) => {
        if (mode == 'common') {
          return Object.keys(state.phenotype.own).length != 0 && Object.keys(state.phenotype.partner).length != 0;
        } else {
          return Object.keys(state.phenotype[mode]).length === 0 ? false : true
        }
      },
      // simple values
      getValueByField: (state) => (field, mode) => {
        let selected = state.phenotype[mode][field];
        return selected ? selected : [];
      },
      // single select values
      getSelectValueByField: (state) => (field, mode) => {
        let selected = state.phenotype[mode][field];
        return selected ? [{key: selected}] : [];
      },
      // multi select values
      getMultiSelectValueByField: (state) => (field, mode) => {
        let selected = state.phenotype[mode][field];
        return selected ? selected.map(e => {
          return { key: e }
        }) : [];
      },
    },
    actions: {
      fetchPhenotype({commit}, mode) {
        axios
          .get(`/api/phenotype/${mode}`)
          .then((response) => {
            let phenotype = response.data.observable_phenotype
            commit('setPhenotype', {
              'data': {
                ...phenotype,
                'ethnicity': {'key': phenotype.ethnicity},
                'race': {'key': phenotype.race},
                'skinColor': {'key': phenotype.skinColor},
                'secondaryEthnicity': phenotype.secondaryEthnicity.map(item => ({key: item}))
              },
              'mode': mode
            });
          })
          .catch((err) => {
            console.error(err);
            if (err.response && err.response.status === 404) {
              commit('setCurrentPhenotype', mode)
              commit('setPhenotype', {
                'data': {},
                'mode': mode
              });
            }
          })
      }, 
      setReturnRoute({commit}, returnRoute) {
        commit('setReturnRoute', returnRoute);
      },
      setPhenotype({commit}, phenotype) {
        commit('setPhenotype', phenotype);
      },
      setCurrentPhenotype({commit}, currentPhenotype) {
        commit('setCurrentPhenotype', currentPhenotype);
      },
      clearReturnRoute({commit}) {
        commit('setReturnRoute', {name: null, path: null, reservation: false});
      },
      clearPhenotype({commit}) {
        commit('setPhenotype', {own: {}, partner: {}});
      },
    },
    mutations: {
      setReturnRoute(state, returnRoute) {
        state.returnRoute = returnRoute;
      },
      setPhenotype(state, phenotype) {
        if (phenotype.mode && phenotype.data) {
          state.phenotype[phenotype.mode] = phenotype.data;
        } else {
          state.phenotype = phenotype;
        }
      },
      setCurrentPhenotype(state, currentPhenotype) {
        state.currentPhenotype = currentPhenotype;
      }
    }
}

export default phenotypeModule;